import type { SVGProps } from "react";
import { memo } from "react";
const Budgets = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#1B660F" />
        <stop offset="100%" stopColor="#6CAE3E" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M49 30v-4.586l-7.293 7.293a1 1 0 0 1-1.332.074l-4.301-3.441-6.367 6.367-1.414-1.414 7-7a1 1 0 0 1 1.332-.074l4.301 3.441 6.66-6.66H43v-2h7a1 1 0 0 1 1 1v7zM26 43h-2V13a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1v30h-2V14H26zM15 64.471v-22.41l12.74 8.82zm25-5.346c.224 0 .447-.067.641-.2l9.956-6.893L63.691 66H16.309l13.094-13.968 9.956 6.893c.194.133.417.2.641.2m12.26-8.244L65 42.061v22.41zm14.398-11.633-8-7-1.316 1.504 6.937 6.071L40 56.632 15.721 39.823l6.937-6.071-1.316-1.504-8 7A1 1 0 0 0 13 40v27a1 1 0 0 0 1 1h52a1 1 0 0 0 1-1V40a1 1 0 0 0-.342-.752"
      />
    </g>
  </svg>
);
const Memo = memo(Budgets);
export default Memo;
